<div class="d-flex align-items-center justify-content-center py-5">
    <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-black-50"></i>
</div>
